var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "addContextMenu",
      style: {
        left: _vm.addMenuPos.x - 70 + "px",
        top: _vm.addMenuPos.y - 70 + "px",
        "max-height": _vm.addMenuPos.height,
      },
      on: {
        keydown: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "down", 40, $event.key, [
                "Down",
                "ArrowDown",
              ])
            ) {
              return null
            }
            return _vm.selectDown.apply(null, arguments)
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
            ) {
              return null
            }
            return _vm.selectUp.apply(null, arguments)
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.handleEnter.apply(null, arguments)
          },
        ],
      },
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.query,
            expression: "query",
          },
        ],
        attrs: {
          id: "context-search",
          type: "search",
          placeholder: _vm.$t("chatbotv2.search"),
          autocomplete: "off",
        },
        domProps: { value: _vm.query },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.query = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _vm._l(_vm.filteredBlockTypes, function (blockType, index) {
        return _c(
          "button",
          {
            key: blockType,
            staticClass: "chatbot-btn",
            class: { selected: index === _vm.selectedIndex },
            attrs: { id: "block_" + blockType },
            on: {
              click: function ($event) {
                return _vm.addBlock(blockType)
              },
            },
          },
          [
            _c(
              "div",
              [
                _c("BlockIconPreview", {
                  staticClass: "img",
                  staticStyle: { "font-size": "16px" },
                  attrs: { "block-type": blockType },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex align-items-center align-content-center justify-content-start",
              },
              [
                _c("span", { staticClass: "blockTypeText" }, [
                  _vm._v(_vm._s(_vm.$t("automation.blocks." + blockType))),
                ]),
              ]
            ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }